import { useMemo } from "react";
import { DoraSelectMultiple } from "dora-shared/frontend";

export default function FeaturesList(props: {
  qualities: string[];
  qualityOptions: { id: string; label: string }[];
  cargoDemands?: boolean;
  label: string;
  onChange: (value: any) => void;
}) {
  const { qualities, qualityOptions, label } = props;
  const values = useMemo(
    () => qualityOptions.filter((x) => qualities.includes(x.id)),
    [qualities, qualityOptions]
  );

  return (
    <div>
      <DoraSelectMultiple
        options={qualityOptions}
        selectedValues={values}
        onChange={(ids) => props.onChange(ids)}
        label={label}
      />
    </div>
  );
}
